import {
  isMenuPublicSite,
  MENU_HOSTING_SITE_ID,
  getAdminBaseUrl,
  getLmenusLoginUrl
} from '@/lib/appShell'
import { isLMenusRestaurant } from '@/lib/lmenus'

/**
 * رابط صفحة البروفايل العام للمطعم (موقع madentak-ban-edak).
 * في لوحة الإدارة اضبط VITE_PUBLIC_MENU_BASE_URL على نطاق موقع المنيو وليس لوحة التحكم.
 * لـ LMenus يمكن ضبط VITE_LMENUS_PUBLIC_BASE_URL (افتراضياً نفس المنيو العام).
 */
export function getPublicMenuBaseUrl() {
  const fromEnv = String(import.meta.env.VITE_PUBLIC_MENU_BASE_URL || '').trim()
  if (fromEnv) return fromEnv.replace(/\/$/, '')

  if (typeof window !== 'undefined' && isMenuPublicSite()) {
    return window.location.origin.replace(/\/$/, '')
  }

  if (import.meta.env.DEV && typeof window !== 'undefined') {
    return window.location.origin.replace(/\/$/, '')
  }

  return `https://${MENU_HOSTING_SITE_ID}.web.app`
}

/** قاعدة روابط LMenus العامة — التقديم + QR */
export function getLmenusPublicBaseUrl() {
  const fromEnv = String(import.meta.env.VITE_LMENUS_PUBLIC_BASE_URL || '').trim()
  if (fromEnv) return fromEnv.replace(/\/$/, '')
  return getPublicMenuBaseUrl()
}

export function getLmenusLandingUrl() {
  return `${getLmenusPublicBaseUrl()}/gusto`
}

export function getLmenusRegisterUrl() {
  return `${getLmenusPublicBaseUrl()}/gusto/register`
}

export { getAdminBaseUrl, getLmenusLoginUrl }

export function slugifyRestaurantFilename(name, fallbackId) {
  const raw = String(name || fallbackId || 'restaurant')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\u0600-\u06FF-]+/g, '')
  return raw || String(fallbackId || 'restaurant')
}

/**
 * رابط المنيو العام.
 * @param {string|object} restaurantIdOrEntity — id أو كائن مطعم
 * @param {object} [entityHint] — حقول إضافية (lmenusSlug, lmenus, name_ar)
 */
export function getRestaurantPublicProfileUrl(restaurantIdOrEntity, entityHint = null) {
  const entity =
    restaurantIdOrEntity && typeof restaurantIdOrEntity === 'object'
      ? restaurantIdOrEntity
      : entityHint && typeof entityHint === 'object'
        ? { id: restaurantIdOrEntity, ...entityHint }
        : { id: restaurantIdOrEntity }

  const id = String(entity?.id || restaurantIdOrEntity || '').trim()
  if (!id && !entity?.lmenusSlug) return ''

  const isLmenus = isLMenusRestaurant(entity) || !!entity?.lmenusSlug
  const slug = String(entity?.lmenusSlug || '').trim()

  if (isLmenus && slug) {
    const base = getLmenusPublicBaseUrl()
    const path = `/m/${encodeURIComponent(slug)}`
    return base ? `${base}${path}` : path
  }

  if (!id) return ''
  const base = getPublicMenuBaseUrl()
  const path = `/r/${encodeURIComponent(id)}`
  return base ? `${base}${path}` : path
}
